import type { ComponentProps } from 'react';

import ArrowRightButton from '@/public/assets/svg/Icon/ArrowRightButton.svg';

export const IconArrowRightButton = ({ ...props }: ComponentProps<'svg'>) => {
  return <ArrowRightButton {...props} />;
};
